import React from 'react';
import { createRoot } from 'react-dom/client';
import GlossaryIconsBlock from './components/glossary-icons-block';
import { IGlossaryIconModel } from './models/glossary-icons-block-models';

const entryDiv = document.getElementById('glossary-icons-block-app');

if (entryDiv) {
    const root = createRoot(entryDiv);
    let glossaryIcons = (window as any).glossaryIconsBlockBootstrap.glossaryIcons as IGlossaryIconModel[];
    let sortDropdownLabel = (window as any).glossaryIconsBlockBootstrap.sortDropdownLabel as string;
    let groupByCategoryString = (window as any).glossaryIconsBlockBootstrap.groupByCategory as string;
    let groupByCategory = groupByCategoryString?.toLowerCase() === 'true';
    root.render(
        <GlossaryIconsBlock
            glossaryIcons={glossaryIcons}
            sortDropdownLabel={sortDropdownLabel}
            groupByCategory={groupByCategory}
            />
    );
}
